import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BackdropComponent } from './backdrop.component';

@NgModule({
  imports: [CommonModule],
  exports: [BackdropComponent],
  declarations: [BackdropComponent]
})
export class BackdropModule {}
